export default __webpack_public_path__ + "static/media/StopAddict.d3e3371c.png";